import 'viewerjs/dist/viewer.css';
import 'antd/lib/upload/style';
import 'antd/lib/button/style';
import 'antd/lib/icon/style';
import 'antd/lib/message/style';
import 'antd/lib/modal/style';


import '../VortexUpload.less';